<template>
  <div class="despachos-container">
    <!-- Pestañas principales -->
    <v-tabs v-model="activeTab" class="mb-4">
      <v-tab value="consolidacion">
        <v-icon start>mdi-package-variant-closed</v-icon>
        Consolidación de Órdenes
      </v-tab>
      <v-tab value="muelles">
        <v-icon start>mdi-truck-delivery</v-icon>
        Gestión de Muelles
      </v-tab>
      <v-tab value="envios">
        <v-icon start>mdi-file-document-outline</v-icon>
        Documentación de Envíos
      </v-tab>
      <!-- <v-tab value="despachos">
        <v-icon start>mdi-clipboard-list</v-icon>
        Historial de Despachos
      </v-tab> -->
    </v-tabs>

    <!-- Contenido de las pestañas -->
    <v-window v-model="activeTab">
      <!-- Pestaña de Consolidación de Órdenes -->
      <v-window-item value="consolidacion">
        <v-card>
        <v-card-title>
        <span>Consolidación de Órdenes Pickeadas</span>
      </v-card-title>

        <v-card-text>
            <!-- Información del flujo operativo -->
            <v-alert type="info" variant="tonal" class="mb-4">
              <v-row>
                <v-col cols="12" md="8">
                  <h6>Flujo Operativo de Despachos:</h6>
                  <p class="mb-2">
                    1. <strong>Seleccionar órdenes</strong> pickeadas → 
                    2. <strong>Consolidar</strong> → 
                    3. <strong>Asignar a muelle</strong> → 
                    4. <strong>Cargar vehículo</strong> → 
                    5. <strong>Generar envío</strong>
                  </p>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="text-center">
                    <v-chip color="success" size="small" class="ma-1">
                      {{ consolidations.length }} Consolidaciones
                    </v-chip>
                    <v-chip color="info" size="small" class="ma-1">
                      {{ shipments.length }} Envíos
                    </v-chip>
                  </div>
                </v-col>
              </v-row>
            </v-alert>

            <!-- Filtros para órdenes pickeadas -->
            <v-row class="mb-4">
              <v-col cols="12" sm="6" md="3">
                <v-select
                  v-model="consolidationFilters.status"
                  :items="[
                    { title: 'Todas', value: '' },
                    { title: 'Pickeadas', value: 'picked' },
                    { title: 'Enviado a Despacho', value: 'shipped' },
                    { title: 'Consolidadas', value: 'consolidated' },
                    { title: 'Asignadas a Muelle', value: 'assigned_to_dock' }
                  ]"
                  label="Estado"
                  hide-details
                  density="compact"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="consolidationFilters.customer"
                  prepend-inner-icon="mdi-account"
                  label="Cliente"
                  hide-details
                  density="compact"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-select
                  v-model="consolidationFilters.priority"
                  :items="[
                    { title: 'Todas', value: '' },
                    { title: 'Urgente', value: 'urgente' },
                    { title: 'Alta', value: 'alta' },
                    { title: 'Normal', value: 'normal' },
                    { title: 'Baja', value: 'baja' }
                  ]"
                  label="Prioridad"
                  hide-details
                  density="compact"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="consolidationFilters.search"
                  prepend-inner-icon="mdi-magnify"
                  label="Buscar orden"
                  hide-details
                  density="compact"
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Tabla de órdenes pickeadas -->
            <ResponsiveDataTable
              v-model="selectedOrders"
              :items="filteredPickedOrders"
              :headers="consolidationHeaders"
              :loading="loadingOrders"
              show-select
              item-value="id"
              return-object
              class="elevation-1"
              items-per-page="10"
              density="default"
              hover
            >
              <template v-slot:item.order_date="{ item }">
                {{ formatDate(item.order_date) }}
              </template>

              <template v-slot:item.priority="{ item }">
                <v-chip
                  :color="getPriorityColor(item.priority)"
                  text-color="white"
                  size="small"
                >
                  {{ item.priority }}
                </v-chip>
              </template>


              <template v-slot:item.status="{ item }">
                <v-chip
                  :color="getStatusColor(item.status)"
                  text-color="white"
                  size="small"
                >
                  {{ getStatusText(item.status) }}
                </v-chip>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn
                  icon="mdi-eye"
                  size="small"
                  variant="text"
                  color="info"
                  @click="viewOrderDetails(item)"
                ></v-btn>
              </template>
            </ResponsiveDataTable>

            <!-- Botones de acción para consolidación -->
            <v-row class="mt-4" v-if="selectedOrders.length > 0">
              <v-col cols="12">
                <v-alert type="info" variant="tonal">
                  {{ selectedOrders.length }} órdenes seleccionadas para consolidación
                </v-alert>
              </v-col>
              <v-col cols="12" class="d-flex gap-2">
                <v-btn
                  color="success"
                  prepend-icon="mdi-package-variant-closed"
                  @click="consolidateOrders"
                  :disabled="!canConsolidate"
                >
                  Consolidar Órdenes
                </v-btn>
                <v-btn
                  color="primary"
                  prepend-icon="mdi-truck"
                  @click="assignToLoadingDock"
                  :disabled="!canAssignToDock"
                >
                  Asignar a Muelle
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-window-item>

      <!-- Pestaña de Gestión de Muelles -->
      <v-window-item value="muelles">
        <v-card>
          <v-card-title class="d-flex justify-space-between align-center">
            <span>Gestión de Muelles de Carga</span>
            <v-btn
              color="primary"
              prepend-icon="mdi-plus"
              @click="showDockModal"
            >
              Nuevo Muelle
            </v-btn>
          </v-card-title>

          <v-card-text>
            <!-- Consolidaciones disponibles para asignar -->
            <v-alert type="info" variant="tonal" class="mb-4" v-if="availableConsolidations.length > 0">
              <h6>Consolidaciones Disponibles para Asignar:</h6>
              <v-row class="mt-2">
                <v-col 
                  v-for="consolidation in availableConsolidations" 
                  :key="consolidation.id"
                  cols="12" md="6" lg="4"
                >
                  <v-card variant="outlined" class="consolidation-card">
                    <v-card-text>
                      <div class="d-flex justify-space-between align-center mb-2">
                        <h6>{{ consolidation.consolidation_number }}</h6>
                        <v-chip color="info" size="small">{{ (consolidation.orders || []).length }} órdenes</v-chip>
                      </div>
                      <p class="text-caption mb-2">
                        <strong>Items totales:</strong> {{ calculateTotalItems(consolidation.orders || []) }}
                      </p>
                      <p class="text-caption mb-2">
                        <strong>Creada:</strong> {{ formatDate(consolidation.created_at) }}
                      </p>
                      <v-btn 
                        size="small" 
                        color="primary" 
                        variant="outlined"
                        @click="showConsolidationToDockModal(consolidation)"
                        block
                      >
                        Asignar a Muelle
                      </v-btn>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-alert>

            <!-- Vista de muelles -->
            <v-row>
              <v-col
                v-for="dock in loadingDocks"
                :key="dock.id"
                cols="12"
                md="6"
                lg="4"
              >
                <v-card
                  :color="getDockStatusColor(dock.status)"
                  variant="outlined"
                  class="dock-card"
                >
                  <v-card-title class="d-flex justify-space-between align-center">
                    <span>{{ dock.name }}</span>
                    <v-chip
                      :color="getDockStatusColor(dock.status)"
                      text-color="white"
                      size="small"
                    >
                      {{ dock.status }}
                    </v-chip>
                  </v-card-title>

                  <v-card-text>
                    <div class="dock-info">
                      <p><strong>Capacidad:</strong> {{ dock.capacity }} pallets</p>
                      <p><strong>Ocupación:</strong> {{ dock.current_load }}/{{ dock.capacity }}</p>
                      <p><strong>Transportista:</strong> {{ dock.carrier || 'No asignado' }}</p>
                      <p><strong>Vehículo:</strong> {{ dock.vehicle_plate || 'No asignado' }}</p>
                      
                      <v-progress-linear
                        :model-value="(dock.current_load / dock.capacity) * 100"
                        :color="getLoadColor(dock.current_load, dock.capacity)"
                        height="8"
                        class="mt-2"
                      ></v-progress-linear>
                    </div>

                    <!-- Consolidaciones asignadas al muelle -->
                    <div v-if="dock.assigned_consolidations && dock.assigned_consolidations.length > 0" class="mt-3">
                      <v-divider class="mb-2"></v-divider>
                      <h4>Consolidaciones Asignadas:</h4>
                      <v-card
                        v-for="consolidation in dock.assigned_consolidations"
                        :key="consolidation.id"
                        variant="outlined"
                        class="ma-1 pa-2"
                        size="small"
                      >
                        <div class="d-flex justify-space-between align-center">
                          <div>
                            <strong>{{ consolidation.consolidation_number }}</strong>
                            <br>
                            <small>{{ consolidation.orders.length }} órdenes | {{ consolidation.total_items }} items</small>
                          </div>
                        </div>
                        
                        <!-- Detalles de órdenes -->
                        <div class="mt-2">
                          <v-chip
                            v-for="order in consolidation.orders"
                            :key="order.id"
                            size="small"
                            class="ma-1"
                            color="primary"
                            variant="outlined"
                          >
                            {{ order.order_number }}
                            <small class="ml-1">({{ order.items_count }} items)</small>
                          </v-chip>
                        </div>
                      </v-card>
                    </div>

                    <!-- Órdenes asignadas al muelle -->
                    <div v-if="dock.assigned_orders && dock.assigned_orders.length > 0" class="mt-3">
                      <v-divider class="mb-2"></v-divider>
                      <h4>Órdenes Asignadas:</h4>
                      <v-chip
                        v-for="order in dock.assigned_orders"
                        :key="order.id"
                        size="small"
                        class="ma-1"
                        closable
                        @click:close="removeOrderFromDock(dock.id, order.id)"
                      >
                        {{ order.order_number }}
                      </v-chip>
                    </div>
                  </v-card-text>

                  <v-card-actions>
                    <v-btn
                      size="small"
                      color="primary"
                      variant="text"
                      @click="editDock(dock)"
                    >
                      Editar
                    </v-btn>
                    <v-btn
                      size="small"
                      color="success"
                      variant="text"
                      @click="startLoading(dock)"
                      :disabled="dock.status !== 'disponible' && dock.status !== 'ocupado'"
                    >
                      Iniciar Carga
                    </v-btn>
                    <v-btn
                      size="small"
                      color="warning"
                      variant="text"
                      @click="completeLoading(dock)"
                      :disabled="dock.status !== 'cargando'"
                    >
                      Completar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-window-item>

      <!-- Pestaña de Documentación de Envíos -->
      <v-window-item value="envios">
        <v-card>
          <v-card-title class="d-flex justify-space-between align-center">
            <span>Documentación de Envíos</span>
            <!-- Botón Nuevo Envío temporalmente oculto -->
            <!-- <v-btn
              color="primary"
              prepend-icon="mdi-file-document-plus"
              @click="showNewShipmentModal"
            >
              Nuevo Envío
            </v-btn> -->
          </v-card-title>

          <v-card-text>
            <!-- Filtros para envíos -->
            <v-row class="mb-4">
              <v-col cols="12" sm="6" md="3">
                <v-select
                  v-model="shipmentFilters.status"
                  :items="[
                    { title: 'Todos', value: '' },
                    { title: 'Preparando', value: 'preparando' },
                    { title: 'En tránsito', value: 'en_transito' },
                    { title: 'Entregado', value: 'entregado' },
                    { title: 'Devuelto', value: 'devuelto' }
                  ]"
                  label="Estado"
                  hide-details
                  density="compact"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="shipmentFilters.tracking"
                  prepend-inner-icon="mdi-barcode"
                  label="Número de seguimiento"
                  hide-details
                  density="compact"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="shipmentFilters.carrier"
                  prepend-inner-icon="mdi-truck"
                  label="Transportista"
                  hide-details
                  density="compact"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="shipmentFilters.dateFrom"
                  label="Fecha desde"
                  type="date"
                  hide-details
                  density="compact"
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Tabla de envíos -->
            <ResponsiveDataTable
              :items="filteredShipments"
              :headers="shipmentHeaders"
              :loading="loadingShipments"
              class="elevation-1"
              items-per-page="10"
              density="default"
              hover
            >
              <template v-slot:item.carrier="{ item }">
                {{ getCarrierName(item.carrier) }}
              </template>

              <template v-slot:item.ship_date="{ item }">
                {{ formatDate(item.ship_date) }}
              </template>

              <template v-slot:item.estimated_delivery="{ item }">
                {{ formatDate(item.estimated_delivery) }}
              </template>


              <template v-slot:item.status="{ item }">
                <v-chip
                  :color="getStatusColor(item.status)"
                  text-color="white"
                  size="small"
                >
                  {{ getStatusText(item.status) }}
                </v-chip>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-tooltip text="Archivar envío">
                  <template v-slot:activator="{ props }">
                    <v-btn
                      v-bind="props"
                      icon="mdi-archive"
                      size="small"
                      variant="text"
                      color="warning"
                      @click="confirmDeleteShipment(item)"
                    ></v-btn>
                  </template>
                </v-tooltip>
                <v-btn
                  icon="mdi-file-pdf-box"
                  size="small"
                  variant="text"
                  color="error"
                  @click="generateShippingLabel(item)"
                ></v-btn>
                <v-btn
                  icon="mdi-truck-fast"
                  size="small"
                  variant="text"
                  color="success"
                  @click="openTracking(item)"
                ></v-btn>
              </template>
            </ResponsiveDataTable>
          </v-card-text>
        </v-card>
      </v-window-item>

      <!-- Pestaña de Historial de Despachos -->
      <v-window-item value="despachos">
        <v-card>
          <v-card-title class="d-flex flex-column flex-md-row justify-space-between align-center ga-2">
            <span>Historial de Despachos</span>
            <div class="d-flex flex-column flex-sm-row ga-2 ga-sm-4 align-center">
              <v-btn
                color="success"
                prepend-icon="mdi-microsoft-excel"
                @click="exportToExcel"
                class="d-none d-sm-flex"
              >
                Exportar Excel
              </v-btn>
              <v-btn
                color="success"
                icon="mdi-microsoft-excel"
                @click="exportToExcel"
                class="d-sm-none"
                size="small"
              ></v-btn>
              <v-btn
                color="primary"
                prepend-icon="mdi-plus"
                @click="showNewDespachoModal"
                class="d-none d-sm-flex"
              >
                Nuevo Despacho
              </v-btn>
              <v-btn
                color="primary"
                icon="mdi-plus"
                @click="showNewDespachoModal"
                class="d-sm-none"
                size="small"
              ></v-btn>
            </div>
          </v-card-title>

          <v-card-text>
            <!-- Filtros originales de egresos -->
        <v-row class="mb-4">
          <v-col cols="12" sm="6" md="3">
            <v-select
              v-model="filters.status"
              :items="[
                { title: 'Todos', value: '' },
                { title: 'Completado', value: 'Completado' },
                { title: 'Pendiente', value: 'Pendiente' },
                { title: 'Cancelado', value: 'Cancelado' }
              ]"
              label="Estado"
              hide-details
              density="compact"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field
              v-model="filters.dateFrom"
              label="Fecha desde"
              type="date"
              hide-details
              density="compact"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field
              v-model="filters.dateTo"
              label="Fecha hasta"
              type="date"
              hide-details
              density="compact"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field
              v-model="filters.search"
              prepend-inner-icon="mdi-magnify"
              label="Buscar"
              hide-details
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

            <!-- Tabla de despachos -->
        <ResponsiveDataTable
              :items="filteredDespachos"
              :headers="despachoHeaders"
          :loading="loading"
          :search="filters.search"
              class="elevation-1 despachos-table"
          items-per-page="10"
          density="default"
          hover
        >
          <template v-slot:item.created_at="{ item }">
            {{ formatDate(item.created_at) }}
          </template>

          <template v-slot:item.destination="{ item }">
            {{ item.destination || 'No especificado' }}
          </template>

          <template v-slot:item.items_count="{ item }">
            {{ item.details?.length || 0 }}
          </template>

          <template v-slot:item.source_location="{ item }">
            {{ getSourceLocationName(item) }}
          </template>

          <template v-slot:item.actions="{ item }">
            <div class="action-buttons">
              <v-btn
                icon="mdi-eye"
                size="small"
                variant="text"
                color="info"
                @click="viewDespacho(item)"
                title="Ver detalles"
              ></v-btn>
              <v-btn
                icon="mdi-pencil"
                size="small"
                variant="text"
                color="primary"
                @click="editDespacho(item)"
                :disabled="item.status !== 'Pendiente'"
                title="Editar"
              ></v-btn>
              <v-btn
                icon="mdi-delete"
                size="small"
                variant="text"
                color="error"
                @click="deleteDespacho(item)"
                :disabled="item.status !== 'Pendiente'"
                title="Eliminar"
              ></v-btn>
            </div>
          </template>
        </ResponsiveDataTable>
          </v-card-text>
        </v-card>
      </v-window-item>
    </v-window>

    <!-- Modales y diálogos aquí -->
    <!-- Modal de Consolidación -->
    <v-dialog v-model="showConsolidationDialog" max-width="800" persistent>
      <v-card>
        <v-card-title>Nueva Consolidación de Órdenes</v-card-title>
        <v-card-text>
          <!-- Contenido del modal de consolidación -->
          <p>Funcionalidad de consolidación en desarrollo...</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showConsolidationDialog = false">Cancelar</v-btn>
          <v-btn color="primary" @click="saveConsolidation">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal de Muelle -->
    <v-dialog v-model="showDockDialog" max-width="600" persistent>
      <v-card>
        <v-card-title>{{ isEditingDock ? 'Editar Muelle' : 'Nuevo Muelle' }}</v-card-title>
        <v-card-text>
          <v-form ref="dockForm">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="dockForm.name"
                  label="Nombre del Muelle"
                  :rules="[v => !!v || 'El nombre es requerido']"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="dockForm.capacity"
                  label="Capacidad (pallets)"
                  type="number"
                  :rules="[v => !!v || 'La capacidad es requerida']"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="dockForm.status"
                  :items="[
                    { title: 'Disponible', value: 'disponible' },
                    { title: 'Ocupado', value: 'ocupado' },
                    { title: 'Mantenimiento', value: 'mantenimiento' }
                  ]"
                  label="Estado"
                  required
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showDockDialog = false">Cancelar</v-btn>
          <v-btn color="primary" @click="saveDock">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal de Envío -->
    <v-dialog v-model="showShipmentDialog" max-width="800" persistent>
      <v-card>
        <v-card-title>Nuevo Envío</v-card-title>
        <v-card-text>
          <!-- Contenido del modal de envío -->
          <p>Funcionalidad de envíos en desarrollo...</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showShipmentDialog = false">Cancelar</v-btn>
          <v-btn color="primary" @click="saveShipment">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal de Detalles de Orden -->
    <v-dialog v-model="showOrderDetailsDialog" max-width="900" persistent>
      <v-card v-if="selectedOrder">
        <v-card-title class="d-flex justify-space-between align-center">
          <span>Detalles de Orden {{ selectedOrder.order_number }}</span>
          <v-chip :color="getOrderStatusColor(selectedOrder.status)" text-color="white">
            {{ getStatusText(selectedOrder.status) }}
          </v-chip>
        </v-card-title>
        
        <v-card-text>
          <v-row>
            <!-- Información general de la orden -->
            <v-col cols="12" md="6">
              <v-card variant="outlined" class="mb-4">
                <v-card-title class="text-h6">Información General</v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="6">
                      <strong>Número de Orden:</strong><br>
                      {{ selectedOrder.order_number }}
                    </v-col>
                    <v-col cols="6">
                      <strong>Cliente:</strong><br>
                      {{ selectedOrder.customer_name }}
                    </v-col>
                    <v-col cols="6">
                      <strong>Fecha de Orden:</strong><br>
                      {{ formatDate(selectedOrder.order_date) }}
                    </v-col>
                    <v-col cols="6">
                      <strong>Prioridad:</strong><br>
                      <v-chip :color="getPriorityColor(selectedOrder.priority)" size="small" text-color="white">
                        {{ selectedOrder.priority }}
                      </v-chip>
                    </v-col>
                    <v-col cols="6">
                      <strong>Total de Orden:</strong><br>
                      {{ formatCurrency(selectedOrder.total_amount) }}
                    </v-col>
                    <v-col cols="6">
                      <strong>Items:</strong><br>
                      {{ selectedOrder.total_items }} productos
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            
            <!-- Información de envío -->
            <v-col cols="12" md="6">
              <v-card variant="outlined" class="mb-4">
                <v-card-title class="text-h6">Información de Envío</v-card-title>
                <v-card-text>
                  <div v-if="selectedOrder.shipping_address">
                    <strong>Dirección:</strong><br>
                    {{ selectedOrder.shipping_address }}<br>
                    {{ selectedOrder.shipping_city }}<br>
                    {{ selectedOrder.shipping_country }}
            </div>
                  <div v-else class="text-muted">
                    No hay información de envío disponible
                  </div>
                  
                  <div v-if="selectedOrder.tracking_number" class="mt-3">
                    <strong>Número de Seguimiento:</strong><br>
                    {{ selectedOrder.tracking_number }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            
            <!-- Líneas de productos -->
            <v-col cols="12">
              <v-card variant="outlined">
                <v-card-title class="text-h6">Productos en la Orden</v-card-title>
                <v-card-text>
                  <v-data-table
                    :items="selectedOrder.order_lines || []"
                    :headers="getProductHeaders(selectedOrder)"
                    density="compact"
                    items-per-page="5"
                  >
                    <template v-slot:item.quantity="{ item }">
                      {{ item.quantity }}
                      <span v-if="item.quantity_allocated && item.quantity_allocated !== item.quantity" class="text-caption text-warning">
                        ({{ item.quantity_allocated }} asignados)
                      </span>
                    </template>
                    
                    <template v-slot:item.unit_price="{ item }">
                      <span v-if="item.unit_price != null && item.unit_price !== 0">
                        {{ formatCurrency(item.unit_price) }}
                      </span>
                      <span v-else class="text-muted">-</span>
                    </template>
                    
                    <template v-slot:item.line_total="{ item }">
                      <span v-if="item.line_total != null && item.line_total !== 0">
                        {{ formatCurrency(item.line_total) }}
                      </span>
                      <span v-else class="text-muted">-</span>
                    </template>
                    
        </v-data-table>
                  
                  <!-- Resumen de totales si hay precios -->
                  <div v-if="hasOrderPricing(selectedOrder)" class="mt-4">
                    <v-divider class="mb-3"></v-divider>
                    <v-row>
                      <v-col cols="12" md="6" class="ml-auto">
                        <div class="text-right">
                          <div class="d-flex justify-space-between mb-2">
                            <strong>Subtotal:</strong>
                            <span>{{ formatCurrency(selectedOrder.subtotal || 0) }}</span>
                          </div>
                          <div v-if="selectedOrder.tax_amount && selectedOrder.tax_amount > 0" class="d-flex justify-space-between mb-2">
                            <strong>Impuestos:</strong>
                            <span>{{ formatCurrency(selectedOrder.tax_amount) }}</span>
                          </div>
                          <div v-if="selectedOrder.shipping_cost && selectedOrder.shipping_cost > 0" class="d-flex justify-space-between mb-2">
                            <strong>Envío:</strong>
                            <span>{{ formatCurrency(selectedOrder.shipping_cost) }}</span>
                          </div>
                          <v-divider class="my-2"></v-divider>
                          <div class="d-flex justify-space-between">
                            <strong class="text-h6">Total:</strong>
                            <strong class="text-h6">{{ formatCurrency(selectedOrder.total_amount || 0) }}</strong>
                          </div>
                          <div v-if="selectedOrder.currency && selectedOrder.currency !== 'CLP'" class="text-caption text-muted">
                            Moneda: {{ selectedOrder.currency }}
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                  
      </v-card-text>
    </v-card>
            </v-col>
            
            <!-- Notas adicionales -->
            <v-col cols="12" v-if="selectedOrder.notes">
              <v-card variant="outlined">
                <v-card-title class="text-h6">Notas</v-card-title>
                <v-card-text>
                  {{ selectedOrder.notes }}
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="showOrderDetailsDialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal de Nuevo Despacho (funcionalidad original) -->
    <v-dialog v-model="showDespachoDialog" max-width="1000" persistent>
      <v-card>
        <v-card-title>{{ isEditingDespacho ? 'Editar Despacho' : 'Nuevo Despacho' }}</v-card-title>
        <v-card-text>
          <v-form ref="egresoForm" @submit.prevent="saveEgreso">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="egresoForm.destination"
                  label="Destino"
                  :rules="[v => !!v || 'El destino es requerido']"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="egresoForm.dispatch_date"
                  label="Fecha de Despacho"
                  type="date"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="egresoForm.source_location_id"
                  :items="locations"
                  item-title="description"
                  item-value="id"
                  label="Ubicación Origen"
                  :rules="[v => !!v || 'La ubicación es requerida']"
                  required
                  clearable
                >
                  <template v-slot:item="{ props, item }">
                    <v-list-item v-bind="props">
                      <v-list-item-title>{{ item.raw.code }} - {{ item.raw.description }}</v-list-item-title>
                    </v-list-item>
                  </template>
                  <template v-slot:selection="{ item }">
                    {{ item.raw.code }} - {{ item.raw.description }}
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" md="6" v-if="isEditingDespacho">
                <v-select
                  v-model="egresoForm.status"
                  :items="[
                    { title: 'Pendiente', value: 'Pendiente' },
                    { title: 'Completado', value: 'Completado' },
                    { title: 'Cancelado', value: 'Cancelado' }
                  ]"
                  label="Estado"
                  :rules="[v => !!v || 'El estado es requerido']"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="egresoForm.selection_method"
                  :items="[
                    { title: 'Sin orden específico', value: 'none' },
                    { title: 'FIFO (First Input First Output)', value: 'fifo' },
                    { title: 'FEFO (First Expired First Output)', value: 'fefo' }
                  ]"
                  label="Método de Selección"
                  hint="FIFO: Prioriza productos más antiguos por fecha de recepción. FEFO: Prioriza productos por fecha de vencimiento."
                  persistent-hint
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="egresoForm.notes"
                  label="Notas"
                  rows="3"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <h6 class="mb-3">Productos</h6>
                <v-card 
                  v-for="(item, index) in egresoForm.items" 
                  :key="index" 
                  class="mb-3" 
                  variant="outlined"
                >
                  <v-card-text>
                    <v-row>
                                             <v-col cols="12" md="6">
                         <v-select
                           v-model="item.product_id"
                           :items="availableProducts"
                           item-title="name"
                           item-value="id"
                           label="Producto"
                           :rules="[v => v !== null && v !== undefined && v !== '' || 'El producto es requerido']"
                           required
                           clearable
                         >
                           <template v-slot:item="{ props, item }">
                             <v-list-item v-bind="props">
                               <v-list-item-title>{{ item.raw.name }}</v-list-item-title>
                               <v-list-item-subtitle>{{ item.raw.sku || 'Sin SKU' }}</v-list-item-subtitle>
                             </v-list-item>
                           </template>
                         </v-select>
                         <!-- Debug info -->
                         <small class="text-muted" v-if="item.product_id === null || item.product_id === undefined">
                           ⚠️ Debug: item.product_id = {{ item.product_id }} ({{ typeof item.product_id }})
                         </small>
                       </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          v-model.number="item.quantity"
                          label="Cantidad"
                          type="number"
                          min="1"
                          :rules="[v => !!v && v > 0 || 'La cantidad debe ser mayor a 0']"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="2" class="d-flex align-items-center">
                        <v-btn
                          icon="mdi-delete"
                          color="error"
                          variant="text"
                          @click="removeProductItem(index)"
                          :disabled="egresoForm.items.length === 1"
                        ></v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" class="text-center">
                <v-btn
                  color="primary"
                  variant="outlined"
                  prepend-icon="mdi-plus"
                  @click="addProductItem"
                >
                  Agregar Producto
                </v-btn>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="secondary" @click="showDespachoDialog = false">Cancelar</v-btn>
              <v-btn color="primary" @click="saveEgreso" :disabled="!isEgresoFormValid">Guardar</v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    
    <!-- Modal de Asignación a Muelle -->
    <v-dialog v-model="showDockAssignmentDialog" max-width="600" persistent>
      <v-card>
        <v-card-title>Asignar Órdenes a Muelle</v-card-title>
        <v-card-text>
          <v-alert type="info" variant="tonal" class="mb-4">
            Selecciona un muelle para asignar {{ selectedOrders.length }} órdenes
          </v-alert>
          
          <v-select
            v-model="selectedDockForAssignment"
            :items="availableDocksForAssignment"
            item-title="display_name"
            item-value="id"
            label="Muelle de Carga"
            :rules="[v => !!v || 'Debe seleccionar un muelle']"
            required
          >
            <template v-slot:item="{ props, item }">
              <v-list-item v-bind="props">
                <v-list-item-title>{{ item.raw.name }}</v-list-item-title>
                <v-list-item-subtitle>
                  Capacidad: {{ item.raw.current_load }}/{{ item.raw.capacity }} | 
                  Estado: {{ item.raw.status }} |
                  Disponible: {{ item.raw.capacity - item.raw.current_load }}
                </v-list-item-subtitle>
              </v-list-item>
            </template>
          </v-select>
          
          <div v-if="selectedDockForAssignment" class="mt-4">
            <v-card variant="outlined">
            <v-card-text>
                <h6>Resumen de Asignación:</h6>
                <p><strong>Muelle:</strong> {{ getSelectedDockInfo?.name }}</p>
                <p><strong>Capacidad actual:</strong> {{ getSelectedDockInfo?.current_load }}/{{ getSelectedDockInfo?.capacity }}</p>
                <p><strong>Órdenes a asignar:</strong> {{ selectedOrders.length }}</p>
                <p><strong>Capacidad después:</strong> {{ (getSelectedDockInfo?.current_load || 0) + selectedOrders.length }}/{{ getSelectedDockInfo?.capacity }}</p>
                
                <v-progress-linear
                  :model-value="((getSelectedDockInfo?.current_load || 0) + selectedOrders.length) / (getSelectedDockInfo?.capacity || 1) * 100"
                  :color="getLoadColor((getSelectedDockInfo?.current_load || 0) + selectedOrders.length, getSelectedDockInfo?.capacity || 1)"
                  height="8"
                  class="mt-2"
                ></v-progress-linear>
            </v-card-text>
          </v-card>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showDockAssignmentDialog = false">Cancelar</v-btn>
          <v-btn 
            color="primary" 
            @click="confirmDockAssignment"
            :disabled="!selectedDockForAssignment"
          >
            Asignar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal para Nuevo Envío -->
    <v-dialog v-model="showNewShipmentDialog" max-width="600" persistent>
      <v-card>
        <v-card-title>Nuevo Envío</v-card-title>
        <v-card-text>
          <v-form ref="newShipmentForm">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="newShipmentForm.shipment_number"
                  label="Número de Envío"
                  readonly
                  prepend-inner-icon="mdi-package-variant"
                  variant="outlined"
                  density="compact"
                ></v-text-field>
              </v-col>
              
              <v-col cols="12" md="6">
                <v-select
                  v-model="newShipmentForm.carrier"
                  :items="carriers"
                  item-title="name"
                  item-value="value"
                  label="Transportista"
                  prepend-inner-icon="mdi-truck"
                  variant="outlined"
                  density="compact"
                  required
                ></v-select>
              </v-col>
              
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="newShipmentForm.tracking_number"
                  label="Número de Seguimiento"
                  prepend-inner-icon="mdi-barcode"
                  variant="outlined"
                  density="compact"
                  hint="Opcional - permite seguimiento automático"
                ></v-text-field>
              </v-col>
              
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="newShipmentForm.ship_date"
                  label="Fecha de Envío"
                  type="date"
                  prepend-inner-icon="mdi-calendar"
                  variant="outlined"
                  density="compact"
                  required
                ></v-text-field>
              </v-col>
              
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="newShipmentForm.estimated_delivery"
                  label="Entrega Estimada"
                  type="date"
                  prepend-inner-icon="mdi-calendar-check"
                  variant="outlined"
                  density="compact"
                  hint="Se calcula automáticamente si se deja vacío"
                ></v-text-field>
              </v-col>
              
              <v-col cols="12">
                <v-textarea
                  v-model="newShipmentForm.notes"
                  label="Notas"
                  prepend-inner-icon="mdi-note-text"
                  variant="outlined"
                  density="compact"
                  rows="3"
                  hint="Notas adicionales sobre el envío"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn 
            color="grey" 
            variant="text" 
            @click="showNewShipmentDialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn 
            color="primary" 
            variant="elevated"
            @click="saveNewShipment"
          >
            Crear Envío
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal para Completar Envío desde Muelle -->
    <v-dialog v-model="showCompleteShipmentDialog" max-width="600" persistent>
      <v-card>
        <v-card-title>Completar Envío - {{ selectedDockForCompletion?.name }}</v-card-title>
        <v-card-text>
          <v-form ref="completeShipmentForm">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="completeShipmentForm.shipment_number"
                  label="Número de Envío"
                  readonly
                  prepend-inner-icon="mdi-package-variant"
                  variant="outlined"
                  density="compact"
                ></v-text-field>
              </v-col>
              
              <v-col cols="12" md="6">
                <v-select
                  v-model="completeShipmentForm.carrier"
                  :items="carriers"
                  item-title="name"
                  item-value="value"
                  label="Transportista"
                  prepend-inner-icon="mdi-truck"
                  variant="outlined"
                  density="compact"
                  required
                ></v-select>
              </v-col>
              
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="completeShipmentForm.tracking_number"
                  label="Número de Seguimiento"
                  prepend-inner-icon="mdi-barcode"
                  variant="outlined"
                  density="compact"
                  hint="Opcional - permite seguimiento automático"
                ></v-text-field>
              </v-col>
              
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="completeShipmentForm.ship_date"
                  label="Fecha de Envío"
                  type="date"
                  prepend-inner-icon="mdi-calendar"
                  variant="outlined"
                  density="compact"
                  required
                ></v-text-field>
              </v-col>
              
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="completeShipmentForm.estimated_delivery"
                  label="Entrega Estimada"
                  type="date"
                  prepend-inner-icon="mdi-calendar-check"
                  variant="outlined"
                  density="compact"
                  hint="Se calcula automáticamente si se deja vacío"
                ></v-text-field>
              </v-col>
              
              <v-col cols="12">
                <v-textarea
                  v-model="completeShipmentForm.notes"
                  label="Notas"
                  prepend-inner-icon="mdi-note-text"
                  variant="outlined"
                  density="compact"
                  rows="3"
                  hint="Notas adicionales sobre el envío"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn 
            color="grey" 
            variant="text" 
            @click="showCompleteShipmentDialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn 
            color="success" 
            variant="elevated"
            @click="saveCompleteShipment"
          >
            Completar Envío
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal de Confirmación de Archivado -->
    <v-dialog v-model="showDeleteShipmentDialog" max-width="400">
      <v-card>
        <v-card-title class="text-h6">Confirmar Archivado</v-card-title>
        <v-card-text>
          <p>¿Está seguro de que desea archivar el envío?</p>
          <p v-if="shipmentToDelete" class="text-subtitle-2 text-grey-600">
            <strong>Envío:</strong> {{ shipmentToDelete.shipment_number }}
          </p>
          <p class="text-caption text-info">
            <v-icon icon="mdi-information" size="small"></v-icon>
            El envío se ocultará del listado principal pero se mantendrá en el historial.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn 
            color="grey" 
            variant="text" 
            @click="showDeleteShipmentDialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn 
            color="warning" 
            variant="elevated"
            @click="deleteShipment"
          >
            Sí, Archivar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as XLSX from 'xlsx'
import { useToast } from 'vue-toastification'
import ResponsiveDataTable from '@/components/ResponsiveDataTable.vue'

export default {
  name: 'Despachos',
  components: {
    ResponsiveDataTable
  },
  setup() {
    const toast = useToast()
    return { toast }
  },
  data() {
    return {
      loading: false,
      activeTab: 'consolidacion',

      // Filtros originales de egresos
      filters: {
        status: '',
        dateFrom: '',
        dateTo: '',
        search: ''
      },

      // Consolidación de órdenes
      consolidationFilters: {
        status: '',
        customer: '',
        priority: '',
        search: ''
      },
      selectedOrders: [],
      loadingOrders: false,
      consolidationHeaders: [
        { title: 'Número de Orden', key: 'order_number', align: 'start', sortable: true },
        { title: 'Cliente', key: 'customer_name', align: 'start', sortable: true },
        { title: 'Fecha', key: 'order_date', align: 'start', sortable: true },
        { title: 'Prioridad', key: 'priority', align: 'center', sortable: true },
        { title: 'Items', key: 'items_count', align: 'end', sortable: true },
        { title: 'Estado', key: 'status', align: 'center', sortable: true },
        { title: 'Acciones', key: 'actions', align: 'center', sortable: false },
      ],

      // Gestión de muelles
      showDockDialog: false,
      isEditingDock: false,
      dockForm: {
        name: '',
        capacity: '',
        status: 'disponible'
      },

      // Modal de asignación a muelle
      showDockAssignmentDialog: false,
      selectedDockForAssignment: null,

      // Documentación de envíos
      shipmentFilters: {
        status: '',
        tracking: '',
        carrier: '',
        dateFrom: ''
      },
      loadingShipments: false,
      shipmentHeaders: [
        { title: 'Número de Envío', key: 'shipment_number', align: 'start', sortable: true },
        { title: 'Transportista', key: 'carrier', align: 'start', sortable: true },
        { title: 'Seguimiento', key: 'tracking_number', align: 'start', sortable: true },
        { title: 'Fecha Envío', key: 'ship_date', align: 'start', sortable: true },
        { title: 'Entrega Estimada', key: 'estimated_delivery', align: 'start', sortable: true },
        { title: 'Acciones', key: 'actions', align: 'center', sortable: false },
      ],
      shipments: [], // Lista de envíos creados

      // Historial de despachos (funcionalidad original)
      despachoHeaders: [
        { title: 'Referencia', key: 'reference', align: 'start', sortable: true },
        { title: 'Fecha', key: 'created_at', align: 'start', sortable: true },
        { title: 'Destino', key: 'destination', align: 'start', sortable: true },
        { title: 'Productos', key: 'items_count', align: 'end', sortable: true },
        { title: 'Origen', key: 'source_location', align: 'start', sortable: true },
      ],

      // Modales
      showConsolidationDialog: false,
      showShipmentDialog: false,
      showDespachoDialog: false,
      isEditingDespacho: false,
      showOrderDetailsDialog: false,
      showNewShipmentDialog: false,
      showDeleteShipmentDialog: false,
      shipmentToDelete: null,
      
      // Formulario para nuevo envío
      newShipmentForm: {
        shipment_number: '',
        carrier: 'propio',
        tracking_number: '',
        ship_date: new Date().toISOString().split('T')[0],
        estimated_delivery: '',
        notes: ''
      },

      // Modal para completar envío desde muelle
      showCompleteShipmentDialog: false,
      completeShipmentForm: {
        shipment_number: '',
        carrier: 'propio',
        tracking_number: '',
        ship_date: new Date().toISOString().split('T')[0],
        estimated_delivery: '',
        notes: ''
      },
      selectedDockForCompletion: null,
      
      // Lista de transportistas chilenos
      carriers: [
        { value: 'propio', name: 'Propio', trackingUrl: '' },
        { value: 'starken', name: 'Starken', trackingUrl: 'https://www.starken.cl/seguimiento?codigo=' },
        { value: 'chilexpress', name: 'Chilexpress', trackingUrl: 'https://www.chilexpress.cl/Views/ChilexpressCL/Resultado-busqueda.aspx?DATA=' },
        { value: 'bluexpress', name: 'Blue Express', trackingUrl: 'https://www.bluex.cl/seguimiento?codigo=' },
        { value: 'dhl', name: 'DHL', trackingUrl: 'https://www.dhl.com/cl-en/home/tracking/tracking-express.html?submit=1&tracking-id=' },
        { value: 'fedex', name: 'FedEx', trackingUrl: 'https://www.fedex.com/fedextrack/?trknbr=' },
        { value: 'ups', name: 'UPS', trackingUrl: 'https://www.ups.com/track?loc=es_CL&tracknum=' },
        { value: 'correos', name: 'Correos de Chile', trackingUrl: 'https://www.correos.cl/SitePages/seguimiento/seguimiento.aspx?envio=' },
        { value: 'turbus_cargo', name: 'Turbus Cargo', trackingUrl: 'https://www.turbus.cl/seguimiento-encomiendas?codigo=' },
        { value: 'por_asignar', name: 'Por asignar', trackingUrl: '' }
      ],

      // Formularios (manteniendo compatibilidad con código original)
      egresoForm: {
        destination: '',
        dispatch_date: '',
        source_location_id: '',
        notes: '',
        status: 'Pendiente',
        selection_method: 'none',
        items: []
      },
      selectedEgreso: null,
      selectedOrder: null,
      showDetailsDialog: false,
      showDeleteDialog: false,
      submitting: false
    }
  },
  computed: {
    ...mapGetters({
      egresos: 'transactions/allEgresos',
      products: 'products/allProducts',
      locations: 'locations/allLocations',
      // Nuevos getters para despachos
      orders: 'transactions/allOrders',
      consolidations: 'transactions/allConsolidations',
      // shipments: 'transactions/allShipments', // Comentado temporalmente
      loadingDocks: 'transactions/allLoadingDocks',
      pickedOrders: 'transactions/pickedOrders',
      availableConsolidations: 'transactions/availableConsolidations'
    }),

    // Computed property directa para shipments (bypass mapGetters)
    shipments() {
      console.log('💡 COMPUTED: shipments() called')
      const storeShipments = this.$store.getters['transactions/allShipments']
      console.log('💡 COMPUTED: Direct store access:', storeShipments)
      console.log('💡 COMPUTED: Length:', storeShipments?.length || 0)
      return storeShipments || []
    },

    filteredPickedOrders() {
      console.log('🔍 Computing filteredPickedOrders...')
      console.log('📦 Raw pickedOrders from store:', this.pickedOrders)
      console.log('📊 Store orders:', this.orders)
      console.log('🎛️ Current filters:', this.consolidationFilters)
      
      let result = this.pickedOrders || []
      console.log('🚀 Initial result:', result.length, 'orders')
      
      // DEBUG: Verificar estructura de órdenes
      if (result.length > 0) {
        console.log('🔎 DEBUG: Primera orden completa:', result[0])
        console.log('🔎 DEBUG: Keys de primera orden:', Object.keys(result[0]))
        console.log('🔎 DEBUG: ID de primera orden:', result[0].id, '(tipo:', typeof result[0].id, ')')
      }
      
      if (this.consolidationFilters.status) {
        const beforeFilter = result.length
        result = result.filter(order => order.status === this.consolidationFilters.status)
        console.log(`📋 Status filter '${this.consolidationFilters.status}': ${beforeFilter} → ${result.length}`)
      }
      
      if (this.consolidationFilters.customer) {
        const beforeFilter = result.length
        result = result.filter(order => 
          order.customer_name.toLowerCase().includes(this.consolidationFilters.customer.toLowerCase())
        )
        console.log(`👤 Customer filter '${this.consolidationFilters.customer}': ${beforeFilter} → ${result.length}`)
      }
      
      if (this.consolidationFilters.priority) {
        const beforeFilter = result.length
        result = result.filter(order => order.priority === this.consolidationFilters.priority)
        console.log(`⭐ Priority filter '${this.consolidationFilters.priority}': ${beforeFilter} → ${result.length}`)
      }
      
      if (this.consolidationFilters.search) {
        const beforeFilter = result.length
        result = result.filter(order => 
          order.order_number.toLowerCase().includes(this.consolidationFilters.search.toLowerCase())
        )
        console.log(`🔎 Search filter '${this.consolidationFilters.search}': ${beforeFilter} → ${result.length}`)
      }
      
      console.log('✅ Final filteredPickedOrders result:', result.length, 'orders')
      console.log('📋 Sample results:', result.slice(0, 3))
      
      // DEBUG: Verificar IDs en el resultado final
      if (result.length > 0) {
        console.log('🔎 DEBUG: IDs en resultado final:', result.map(o => ({ id: o.id, number: o.order_number })))
      
      return result
      }
      
    },

    // Condiciones para habilitar botones según órdenes seleccionadas
    canConsolidate() {
      if (this.selectedOrders.length < 2) return false
      return this.selectedOrders.every(order => order.status === 'picked' || order.status === 'shipped')
    },

    canAssignToDock() {
      if (this.selectedOrders.length === 0) return false
      return this.selectedOrders.every(order => order.status === 'picked' || order.status === 'shipped')
    },

    filteredDespachos() {
    },

    filteredDespachos() {
      if (!this.egresos || !Array.isArray(this.egresos)) {
        return []
      }
      
      let result = this.egresos
      
      if (this.filters.status) {
        result = result.filter(egreso => egreso.status === this.filters.status)
      }
      
      if (this.filters.dateFrom) {
        result = result.filter(egreso => {
          const egresoDate = new Date(egreso.created_at).toISOString().split('T')[0]
          return egresoDate >= this.filters.dateFrom
        })
      }
      
      if (this.filters.dateTo) {
        result = result.filter(egreso => {
          const egresoDate = new Date(egreso.created_at).toISOString().split('T')[0]
          return egresoDate <= this.filters.dateTo

      return result
        })
      }

    },

    filteredShipments() {
      console.log('🔍 Computing filteredShipments...')
      
      // Acceder directamente al store para evitar problemas de timing
      const storeShipments = this.$store.getters['transactions/allShipments'] || []
      console.log('📦 Raw shipments from store:', storeShipments)
      console.log('📦 Shipments length:', storeShipments?.length || 0)
      
      // Usar datos reales de envíos creados desde el backend
      let result = [...storeShipments]
      
      console.log('📊 Initial shipments result:', result.length, 'shipments')
      
      // Si tenemos shipments, mostrar información de debug
      if (result.length > 0) {
        console.log('🔎 First shipment:', result[0])
        console.log('🔎 Shipment keys:', Object.keys(result[0]))
      }
      
      // Aplicar filtros
      if (this.shipmentFilters.status) {
        const beforeFilter = result.length
        result = result.filter(shipment => shipment.status === this.shipmentFilters.status)
        console.log(`📋 Status filter '${this.shipmentFilters.status}': ${beforeFilter} → ${result.length}`)
      }
      
      if (this.shipmentFilters.tracking) {
        const beforeFilter = result.length
        result = result.filter(shipment => 
          shipment.tracking_number && shipment.tracking_number.toLowerCase().includes(this.shipmentFilters.tracking.toLowerCase())
        )
        console.log(`🔍 Tracking filter '${this.shipmentFilters.tracking}': ${beforeFilter} → ${result.length}`)
      }
      
      if (this.shipmentFilters.carrier) {
        const beforeFilter = result.length
        result = result.filter(shipment => 
          shipment.carrier && shipment.carrier.toLowerCase().includes(this.shipmentFilters.carrier.toLowerCase())
        )
        console.log(`🚛 Carrier filter '${this.shipmentFilters.carrier}': ${beforeFilter} → ${result.length}`)
      }
      
      if (this.shipmentFilters.dateFrom) {
        const beforeFilter = result.length
        result = result.filter(shipment => {
          if (!shipment.ship_date) return false
          const shipDate = new Date(shipment.ship_date).toISOString().split('T')[0]
          return shipDate >= this.shipmentFilters.dateFrom
        })
        console.log(`📅 Date from filter '${this.shipmentFilters.dateFrom}': ${beforeFilter} → ${result.length}`)
      }
      
      console.log('✅ Final filteredShipments result:', result.length, 'shipments')
      console.log('📋 Sample filtered results:', result.slice(0, 3))
      
      return result
    },

    isEgresoFormValid() {
      const baseValidation = (
        this.egresoForm.destination &&
        this.egresoForm.source_location_id &&
        this.egresoForm.items.length > 0 &&
        this.egresoForm.items.every(item => item.product_id !== null && item.product_id !== undefined && item.quantity > 0)
      )
      
      // En modo edición, también validar que el estado esté presente
      if (this.isEditingDespacho) {
        return baseValidation && this.egresoForm.status
      }
      
      return baseValidation
    },

    availableProducts() {
      // Asegurar que los productos tengan IDs como números
      const products = (this.products || []).map(product => ({
        ...product,
        id: parseInt(product.id)
      }))
      
      console.log('Available products with numeric IDs:', products)
      
      // Si no hay bodega seleccionada, mostrar todos los productos
      if (!this.egresoForm.source_location_id) {
        return products
      }
      
      // Filtrar productos disponibles en la bodega seleccionada
      // En una implementación real, esto debería consultar el inventario
      return products
    },

    availableDocksForAssignment() {
      return this.loadingDocks.map(dock => ({
        id: dock.id,
        name: dock.name,
        current_load: dock.current_load,
        capacity: dock.capacity,
        status: dock.status,
        display_name: `${dock.name} - ${dock.status} (${dock.current_load}/${dock.capacity})`
      }))
    },

    getSelectedDockInfo() {
      return this.loadingDocks.find(dock => dock.id === this.selectedDockForAssignment)
    },

    availableConsolidations() {
      const consolidations = this.consolidations || []
      return consolidations.filter(consolidation => !consolidation.assigned_dock)
    }
  },

  watch: {
    // Watcher para debuggear cambios en shipments
    shipments: {
      handler(newShipments, oldShipments) {
        console.log('📦 WATCHER: shipments changed!')
        console.log('📦 WATCHER: Old shipments:', oldShipments?.length || 0)
        console.log('📦 WATCHER: New shipments:', newShipments?.length || 0)
        
        if (newShipments && newShipments.length > 0) {
          console.log('✅ WATCHER: Shipments data is now available!')
          console.log('🔎 WATCHER: First shipment:', newShipments[0])
        }
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    ...mapActions({
      fetchEgresos: 'transactions/fetchEgresos',
      fetchProducts: 'products/fetchProducts',
      fetchLocations: 'locations/fetchLocations',
      // Nuevas acciones para despachos
      fetchOrders: 'transactions/fetchOrders',
      fetchConsolidations: 'transactions/fetchConsolidations',
      fetchShipments: 'transactions/fetchShipments',
    deleteShipmentAction: 'transactions/deleteShipment',
      fetchLoadingDocks: 'transactions/fetchLoadingDocks',
      createConsolidation: 'transactions/createConsolidation',
      updateOrderStatus: 'transactions/updateOrderStatus',
      createShipment: 'transactions/createShipment',
      createLoadingDock: 'transactions/createLoadingDock',
      updateLoadingDock: 'transactions/updateLoadingDock',
      startDockLoading: 'transactions/startDockLoading',
      completeDockLoading: 'transactions/completeDockLoading',
      assignConsolidationToDock: 'transactions/assignConsolidationToDock',
      downloadShipmentManifest: 'transactions/downloadShipmentManifest'
    }),

    formatDate(date) {
      if (!date) return ''
      return new Date(date).toLocaleDateString('es-ES')
    },

    getPriorityColor(priority) {
      const colors = {
        urgente: 'error',
        alta: 'warning',
        normal: 'success',
        baja: 'info'
      }
      return colors[priority] || 'grey'
    },

    getOrderStatusColor(status) {
      const colors = {
        pending: 'orange',
        assigned: 'blue',
        picking: 'purple',
        picked: 'success',
        shipped: 'success',  // Shipped to dispatch area (same as picked)
        consolidated: 'info',
        assigned_to_dock: 'warning',
        delivered: 'primary',  // Actually delivered to customer
        cancelled: 'error'
      }
      return colors[status] || 'grey'
    },

    getDockStatusColor(status) {
      const colors = {
        disponible: 'success',
        ocupado: 'warning',
        cargando: 'info',
        mantenimiento: 'error'
      }
      return colors[status] || 'grey'
    },

    getLoadColor(currentLoad, capacity) {
      const percentage = (currentLoad / capacity) * 100
      if (percentage >= 90) return 'error'
      if (percentage >= 70) return 'warning'
      return 'success'
    },

    getShipmentStatusColor(status) {
      const colors = {
        preparando: 'warning',
        en_transito: 'info',
        entregado: 'success',
        devuelto: 'error'
      }
      return colors[status] || 'grey'
    },

    getStatusColor(status) {
      const colors = {
        // Estados de órdenes
        'pending': 'orange',
        'assigned': 'blue',
        'picking': 'purple',
        'picked': 'green',
        'shipped': 'green',
        'consolidated': 'teal',
        'assigned_to_dock': 'indigo',
        'delivered': 'success',
        'cancelled': 'error',
        // Estados de egresos/despachos
        'Completado': 'success',
        'Pendiente': 'warning',
        'Cancelado': 'error'
      }
      return colors[status] || 'grey'
    },

    getStatusText(status) {
      const statusTexts = {
        // Estados de órdenes - flujo completo
        'pending': 'Pendiente',
        'assigned': 'Asignado',
        'picking': 'Recolectando',
        'picked': 'Pickeado',
        'shipped': 'Pickeado',  // Shipped = Pickeado (enviado a despacho)
        'consolidated': 'Consolidado',
        'assigned_to_dock': 'Asignado a Muelle',
        'delivered': 'Entregado',
        'cancelled': 'Cancelado',
        // Estados de egresos/despachos
        'Completado': 'Completado',
        'Pendiente': 'Pendiente',
        'Cancelado': 'Cancelado'
      }
      return statusTexts[status] || status
    },

    getSourceLocationName(egreso) {
      if (!egreso.details || egreso.details.length === 0) return 'No especificado'
      const firstDetail = egreso.details[0]
      return firstDetail.source_location ?
        `${firstDetail.source_location.code} - ${firstDetail.source_location.description}` :
        'No especificado'
    },

    showConsolidationModal() {
      this.showConsolidationDialog = true
    },

    consolidateOrders() {
      if (this.selectedOrders.length === 0) return

      console.log('Consolidando órdenes:', this.selectedOrders.length, 'órdenes seleccionadas')
      console.log('DEBUG: selectedOrders completo:', this.selectedOrders)
      console.log('DEBUG: Primer orden completa:', this.selectedOrders[0])
      
      // Verificar qué IDs estamos extrayendo
      const orderIds = this.selectedOrders.map(order => {
        console.log('DEBUG: Orden individual:', order)
        console.log('DEBUG: order.id =', order.id, '(tipo:', typeof order.id, ')')
        return order.id
      })
      
      console.log('DEBUG: orderIds extraídos:', orderIds)
      
      // Preparar datos para la consolidación
      const consolidationData = {
        consolidation_number: `CONS-${String(this.consolidations.length + 1).padStart(3, '0')}`,
        notes: 'Consolidación automática desde interfaz de despachos'
      }
      
      console.log('DEBUG: Datos a enviar al backend:', {
        orderIds,
        consolidationData
      })
      
      // Usar la acción del store para crear la consolidación
      this.createConsolidation({ orderIds, consolidationData })
        .then(consolidation => {
          console.log('Consolidación creada:', consolidation.consolidation_number)
          this.toast.success(`${this.selectedOrders.length} órdenes consolidadas exitosamente. Consolidación: ${consolidation.consolidation_number}`)
          // Recargar órdenes para actualizar la vista
          this.fetchOrders()
          this.selectedOrders = []
          
          // Cambiar automáticamente a la pestaña de muelles para continuar el flujo
          setTimeout(() => {
            this.activeTab = 'muelles'
            this.toast.info('Ahora puedes asignar la consolidación a un muelle de carga')
          }, 2000)
        })
        .catch(error => {
          console.error('Error creando consolidación:', error)
          this.toast.error('Error al crear la consolidación')
        })
    },

    assignToLoadingDock() {
      if (this.selectedOrders.length === 0) return

      // Mostrar modal para seleccionar muelle
      this.showDockAssignmentDialog = true
    },
    
    confirmDockAssignment() {
      if (!this.selectedDockForAssignment || this.selectedOrders.length === 0) return
      
      const dock = this.loadingDocks.find(d => d.id === this.selectedDockForAssignment)
      if (!dock) return
      
      // Verificar capacidad
      const totalNewLoad = this.selectedOrders.length
      if (dock.current_load + totalNewLoad > dock.capacity) {
        this.toast.error(`El muelle ${dock.name} no tiene capacidad suficiente. Capacidad disponible: ${dock.capacity - dock.current_load}`)
        return
      }
      
      // Buscar si hay una consolidación asociada a estas órdenes
      const consolidation = this.consolidations.find(c => 
        c.orders && c.orders.some(order => this.selectedOrders.some(selected => selected.id === order.id))
      )
      
      if (consolidation) {
        // Asignar consolidación completa al muelle - usar la acción del store
        this.assignConsolidationToDock({ consolidationId: consolidation.id, dockId: this.selectedDockForAssignment })
          .then(() => {
            this.toast.success(`Consolidación ${consolidation.consolidation_number} asignada al ${dock.name}`)
            this.selectedOrders = []
            this.showDockAssignmentDialog = false
            this.selectedDockForAssignment = null
            
            // Refrescar datos después de la asignación
            this.fetchConsolidations()
            this.fetchLoadingDocks()
          })
          .catch(error => {
            console.error('Error asignando consolidación al muelle:', error)
            this.toast.error('Error al asignar la consolidación al muelle')
          })
      } else {
        // Asignar órdenes individuales (funcionalidad futura)
        this.toast.info('Asignación de órdenes individuales no implementada aún. Use consolidaciones.')
        this.showDockAssignmentDialog = false
        this.selectedDockForAssignment = null
            
            // Refrescar datos después de la asignación
            this.fetchConsolidations()
            this.fetchLoadingDocks()
      }
    },

    showConsolidationToDockModal(consolidation) {
      // Seleccionar las órdenes de la consolidación
      this.selectedOrders = consolidation.orders || []
      // Mostrar modal para seleccionar muelle
      this.showDockAssignmentDialog = true
    },

    viewOrderDetails(order) {
      console.log('Ver detalles de orden:', order)
      this.selectedOrder = order
      this.showOrderDetailsDialog = true
    },

    showDockModal() {
      this.isEditingDock = false
      this.dockForm = {
        name: '',
        capacity: '',
        status: 'disponible'
      }
      this.showDockDialog = true
    },

    editDock(dock) {
      this.isEditingDock = true
      this.dockForm = { ...dock }
      this.showDockDialog = true
    },

    saveDock() {
      if (this.isEditingDock) {
        // Actualizar muelle existente
        this.updateLoadingDock({ 
          dockId: this.dockForm.id, 
          dockData: {
            name: this.dockForm.name,
            capacity: parseInt(this.dockForm.capacity),
            status: this.dockForm.status
          }
        })
        .then(() => {
          this.toast.success('Muelle actualizado exitosamente')
          this.showDockDialog = false
        })
        .catch(error => {
          console.error('Error actualizando muelle:', error)
          this.toast.error('Error al actualizar el muelle')
        })
      } else {
        // Crear nuevo muelle
        this.createLoadingDock({
          name: this.dockForm.name,
          capacity: parseInt(this.dockForm.capacity),
          status: this.dockForm.status
        })
        .then(() => {
          this.toast.success('Muelle creado exitosamente')
          this.showDockDialog = false
        })
        .catch(error => {
          console.error('Error creando muelle:', error)
          this.toast.error('Error al crear el muelle')
        })
      }
    },

    startLoading(dock) {
      this.startDockLoading({ dockId: dock.id })
        .then(() => {
          this.toast.success(`Carga iniciada en ${dock.name}`)
          // Refrescar los datos de los muelles para mostrar el estado actualizado
          this.fetchLoadingDocks()
        })
        .catch(error => {
          console.error('Error iniciando carga:', error)
          this.toast.error('Error al iniciar la carga')
        })
    },

    completeLoading(dock) {
      // Buscar órdenes en las consolidaciones asignadas
      const assignedOrders = (dock.assigned_consolidations && dock.assigned_consolidations.length > 0)
        ? dock.assigned_consolidations.flatMap(c => c.orders)
        : [];

      if (!assignedOrders.length) {
        this.toast.warning('No hay órdenes asignadas a este muelle')
        return
      }

      // Preparar formulario para completar envío
      this.selectedDockForCompletion = dock
      
      this.completeShipmentForm = {
        shipment_number: 'Se generará automáticamente',
        carrier: 'propio',
        tracking_number: '',
        ship_date: new Date().toISOString().split('T')[0],
        estimated_delivery: '',
        notes: `Envío desde ${dock.name}`
      }
      
      // Mostrar modal para completar información
      this.showCompleteShipmentDialog = true
    },

    async saveCompleteShipment() {
      if (!this.selectedDockForCompletion) {
        this.toast.error('Información requerida faltante')
        return
      }

      try {
        // Calcular fecha estimada si no se proporcionó
        if (!this.completeShipmentForm.estimated_delivery && this.completeShipmentForm.ship_date) {
          const shipDate = new Date(this.completeShipmentForm.ship_date)
          shipDate.setDate(shipDate.getDate() + 3) // 3 días por defecto
          this.completeShipmentForm.estimated_delivery = shipDate.toISOString().split('T')[0]
        }

        // Completar la carga del muelle con la información del envío
        const completionData = {
          shipment_data: {
            carrier: this.completeShipmentForm.carrier,
            tracking_number: this.completeShipmentForm.tracking_number,
            ship_date: this.completeShipmentForm.ship_date,
            estimated_delivery: this.completeShipmentForm.estimated_delivery,
            notes: this.completeShipmentForm.notes,
            status: 'shipped'
          }
        }

        const response = await this.completeDockLoading({ 
          dockId: this.selectedDockForCompletion.id, 
          completionData 
        })

        const shipment = response.shipment
        if (shipment) {
          this.toast.success(`Carga completada en ${this.selectedDockForCompletion.name}. Envío ${shipment.shipment_number} creado`)
          this.fetchLoadingDocks()
          this.fetchShipments()
          this.showCompleteShipmentDialog = false
          this.selectedDockForCompletion = null
          
          setTimeout(() => {
            this.activeTab = 'envios'
            this.toast.info('Revisa la documentación del envío en la pestaña actual')
          }, 2000)
        } else {
          this.toast.success(`Carga completada en ${this.selectedDockForCompletion.name}`)
          this.showCompleteShipmentDialog = false
          this.selectedDockForCompletion = null
        }
      } catch (error) {
        console.error('Error completando carga:', error)
        this.toast.error('Error al completar la carga')
        this.showCompleteShipmentDialog = false
        this.selectedDockForCompletion = null
      }
    },

    removeOrderFromDock(dockId, orderId) {
      const dock = this.loadingDocks.find(d => d.id === dockId)
      if (dock) {
        dock.assigned_orders = dock.assigned_orders.filter(o => o.id !== orderId)
        dock.current_load = Math.max(0, dock.current_load - 1)
      }
    },

    showShipmentModal() {
      this.showShipmentDialog = true
    },

    saveShipment() {
      console.log('Guardando envío...')
      this.toast.success('Envío creado exitosamente')
      this.showShipmentDialog = false
    },

    viewShipmentDetails(shipment) {
      console.log('Ver detalles de envío:', shipment)
    },

    generateShippingLabel(shipment) {
      console.log('Descargando manifiesto para envío:', shipment)
      
      // Verificar si el envío tiene PDF generado
      if (!shipment.pdf_generated && !shipment.pdf_filename) {
        console.log('⚠️ PDF no disponible para shipment:', shipment.id)
        this.$toast?.warning('Este envío aún no tiene manifiesto PDF generado') || 
        alert('Este envío aún no tiene manifiesto PDF generado')
        return
      }
      
      console.log('📥 Iniciando descarga de manifiesto para shipment ID:', shipment.id)
      
      this.downloadShipmentManifest(shipment.id)
        .then(() => {
          console.log('✅ Manifiesto descargado exitosamente')
          this.$toast?.success('Manifiesto descargado exitosamente') || 
          alert('Manifiesto descargado exitosamente')
        })
        .catch((error) => {
          console.error('❌ Error descargando manifiesto:', error)
          console.error('❌ Error details:', error.response?.data || error.message)
          this.$toast?.error('No se pudo descargar el manifiesto') || 
          alert('No se pudo descargar el manifiesto')
        })
    },

    trackShipment(shipment) {
      console.log('Rastreando envío:', shipment)
      window.open(`https://tracking.example.com/${shipment.tracking_number}`, '_blank')
    },

    showNewDespachoModal() {
      this.isEditingDespacho = false
      this.resetEgresoForm()
      this.showDespachoDialog = true
    },

    editDespacho(despacho) {
      this.isEditingDespacho = true
      this.selectedEgreso = despacho

      // Lógica de edición
      if (!this.products || this.products.length === 0) {
        this.fetchProducts()
      }

      const sourceLocationId = despacho.details && despacho.details.length > 0
        ? despacho.details[0].source_location?.id
        : ''

      const mappedItems = despacho.details.map(item => {
        let productId = item.product_id || item.product?.id || item.productId
        if (productId) {
          productId = parseInt(productId)
        }
        
        return {
          id: item.id,
          product_id: productId,
          quantity: item.quantity
        }
      })
      
      this.egresoForm = {
        id: despacho.id,
        destination: despacho.destination || '',
        dispatch_date: new Date(despacho.created_at).toISOString().split('T')[0],
        source_location_id: sourceLocationId,
        notes: despacho.notes || '',
        status: despacho.status || 'Pendiente',
        selection_method: despacho.selection_method || (despacho.use_fifo ? 'fifo' : 'none'),
        items: mappedItems
      }
      
      this.$nextTick(() => {
        this.showDespachoDialog = true
      })
    },

    viewDespacho(despacho) {
      this.selectedEgreso = despacho
      this.showDetailsDialog = true
    },

    deleteDespacho(despacho) {
      this.selectedEgreso = despacho
      this.showDeleteDialog = true
    },

    saveDespacho() {
      console.log('Guardando despacho:', this.egresoForm)
      this.toast.success('Despacho guardado exitosamente')
      this.showDespachoDialog = false
    },

    saveConsolidation() {
      console.log('Guardando consolidación...')
      this.toast.success('Consolidación guardada exitosamente')
      this.showConsolidationDialog = false
    },

    resetEgresoForm() {
      this.egresoForm = {
        destination: '',
        dispatch_date: '',
        source_location_id: '',
        notes: '',
        status: 'Pendiente',
        selection_method: 'none',
        items: [{
          product_id: null,
          quantity: 1
        }]
      }
    },

    addProductItem() {
      this.egresoForm.items.push({
        product_id: null,
        quantity: 1
      })
    },

    removeProductItem(index) {
      if (this.egresoForm.items.length > 1) {
        this.egresoForm.items.splice(index, 1)
      }
    },

    saveEgreso() {
      if (!this.isEgresoFormValid) {
        this.toast.error('Por favor complete todos los campos requeridos')
        return
      }

      this.submitting = true

      // Preparar datos para envío
      const egresoData = {
        ...this.egresoForm,
        items: this.egresoForm.items.map(item => ({
          product_id: parseInt(item.product_id),
          quantity: parseInt(item.quantity)
        }))
      }

      console.log('Datos del egreso a enviar:', egresoData)

      // Simular guardado
      setTimeout(() => {
        this.submitting = false
        this.showDespachoDialog = false
        this.toast.success(this.isEditingDespacho ? 'Despacho actualizado exitosamente' : 'Despacho creado exitosamente')
        this.fetchEgresos()
      }, 1000)
    },

    exportToExcel() {
      const data = this.filteredDespachos.map(despacho => ({
        'Referencia': despacho.reference,
        'Fecha': this.formatDate(despacho.created_at),
        'Destino': despacho.destination || 'No especificado',
        'Estado': despacho.status,
        'Productos': despacho.details?.length || 0,
        'Origen': this.getSourceLocationName(despacho)
      }))

      // CORRECCIÓN: separar en dos `const` con punto y coma
      const ws = XLSX.utils.json_to_sheet(data)
      const wb = XLSX.utils.book_new()

      XLSX.utils.book_append_sheet(wb, ws, 'Despachos')
      XLSX.writeFile(wb, `despachos_${new Date().toISOString().split('T')[0]}.xlsx`)
    },

    // Función auxiliar para calcular items totales de forma segura
    calculateTotalItems(orders) {
      // Convertir proxy a array normal si es necesario
      const ordersArray = Array.isArray(orders) ? orders : (orders ? [orders] : [])
      
      if (ordersArray.length === 0) {
        console.warn('calculateTotalItems: no hay órdenes para calcular')
        return 0
      }
      
      const total = ordersArray.reduce((sum, order) => {
        if (!order) return sum
        
        // Intentar diferentes propiedades para contar items
        let itemCount = 0
        if (order.items_count !== undefined) {
          itemCount = Number(order.items_count) || 0
        } else if (order.order_lines && Array.isArray(order.order_lines)) {
          itemCount = order.order_lines.length
        } else if (order.lines && Array.isArray(order.lines)) {
          itemCount = order.lines.length
        } else {
          itemCount = 0
        }
        
        console.log(`Orden ${order.order_number || order.id || 'sin número'}: ${itemCount} items`)
        return sum + itemCount
      }, 0)
      
      console.log(`Total items calculado: ${total} para ${ordersArray.length} órdenes`)
      return total
    },



    formatCurrency(value) {
      if (value == null || value === 0) return '0'
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(value)
    },

    getProductHeaders(order) {
      return [
        { title: 'Producto', key: 'product_name', align: 'start' },
        { title: 'SKU', key: 'product_sku', align: 'start' },
        { title: 'Cantidad Pedida', key: 'quantity', align: 'end' },
        { title: 'Precio Unitario', key: 'unit_price', align: 'end' },
        { title: 'Total Línea', key: 'line_total', align: 'end' },
      ]
    },

    hasOrderPricing(order) {
      return order.unit_price !== null && order.unit_price !== undefined && order.line_total !== null && order.line_total !== undefined
    },

    formatCurrency(value) {
      if (value == null || value === 0) return '0'
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(value)
    },

    formatCurrency(value) {
      if (value == null || value === 0) return '0'
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(value)
    },

    // Métodos para gestión de envíos
    showNewShipmentModal() {
      this.newShipmentForm = {
        shipment_number: 'Se generará automáticamente',
        carrier: 'propio',
        tracking_number: '',
        ship_date: new Date().toISOString().split('T')[0],
        estimated_delivery: '',
        notes: ''
      }
      
      this.showNewShipmentDialog = true
    },

    saveNewShipment() {
      // Calcular fecha estimada si no se proporcionó
      if (!this.newShipmentForm.estimated_delivery && this.newShipmentForm.ship_date) {
        const shipDate = new Date(this.newShipmentForm.ship_date)
        shipDate.setDate(shipDate.getDate() + 3) // 3 días por defecto
        this.newShipmentForm.estimated_delivery = shipDate.toISOString().split('T')[0]
      }

      const shipmentData = {
        carrier: this.newShipmentForm.carrier,
        tracking_number: this.newShipmentForm.tracking_number,
        ship_date: this.newShipmentForm.ship_date,
        estimated_delivery: this.newShipmentForm.estimated_delivery,
        notes: this.newShipmentForm.notes,
        status: 'preparando'
      }

      console.log('Creating new shipment:', shipmentData)

      this.createShipment(shipmentData)
        .then(() => {
          this.toast.success('Envío creado exitosamente')
          this.showNewShipmentDialog = false
          this.fetchShipments()
        })
        .catch(error => {
          console.error('Error creating shipment:', error)
          this.toast.error('Error al crear el envío')
        })
    },

    getCarrierName(carrierValue) {
      const carrier = this.carriers.find(c => c.value === carrierValue)
      return carrier ? carrier.name : carrierValue || 'Propio'
    },

    openTracking(shipment) {
      if (!shipment.tracking_number) {
        this.toast.info('Sin seguimiento')
        return
      }

      // Si es transportista propio, no hay seguimiento externo
      if (shipment.carrier === 'propio') {
        this.toast.info('Transportista propio - Sin seguimiento externo')
        return
      }

      const carrier = this.carriers.find(c => c.value === shipment.carrier)
      if (!carrier || !carrier.trackingUrl) {
        this.toast.warning('URL de seguimiento no disponible para este transportista')
        return
      }

      const trackingUrl = carrier.trackingUrl + shipment.tracking_number
      window.open(trackingUrl, '_blank')
    },

    confirmDeleteShipment(shipment) {
      this.shipmentToDelete = shipment
      this.showDeleteShipmentDialog = true
    },

    async deleteShipment() {
      if (!this.shipmentToDelete) return

      try {
        console.log('Deleting shipment:', this.shipmentToDelete.id)
        
        // Usar la acción del store que usa apiClient
        await this.deleteShipmentAction(this.shipmentToDelete.id)
        
        console.log('Shipment archived successfully')
        this.toast.success('Envío archivado exitosamente')
        this.showDeleteShipmentDialog = false
        this.shipmentToDelete = null
        
      } catch (error) {
        console.error('Error deleting shipment:', error)
        this.toast.error(error.message || error.response?.data?.error || 'Error al archivar el envío')
        this.showDeleteShipmentDialog = false
        this.shipmentToDelete = null
      }
    }
  },

  mounted() {
    console.log('🚀 Despachos component mounted')
    
    // Debug: Exponer función global para testing
    window.testShipments = () => {
      console.log('🧪 Testing shipments API directly...')
      this.fetchShipments()
        .then(data => {
          console.log('🧪 Direct test result:', data)
        })
        .catch(error => {
          console.error('🧪 Direct test error:', error)
        })
    }
    
    // Fetch all necessary data from backend APIs
    this.fetchEgresos()
    this.fetchProducts()
    this.fetchLocations()
    
    // Fetch new dispatch-related data
    console.log('📦 Fetching dispatch data...')
    this.fetchOrders()
      .then(data => {
        console.log('✅ Orders fetched:', data?.length || 0, 'orders')
        console.log('📊 Order statuses:', data?.map(o => o.status) || [])
        console.log('🎯 Sample order:', data?.[0] || 'No orders')
      })
      .catch(error => {
        console.error('❌ Error fetching orders:', error)
      })
    
    this.fetchConsolidations()
      .then(data => console.log('✅ Consolidations fetched:', data?.length || 0))
      .catch(error => console.error('❌ Error fetching consolidations:', error))
    
    console.log('🚀 Starting fetchShipments call...')
    
    this.fetchShipments()
      .then(data => {
        console.log('✅ Shipments fetched successfully!')
        console.log('📦 Shipments data:', data)
        console.log('📊 Number of shipments:', data?.length || 0)
        console.log('🔍 Type of data:', typeof data, Array.isArray(data))
        
        if (data && data.length > 0) {
          console.log('🔎 First shipment example:', data[0])
          console.log('🔎 Shipment structure:', Object.keys(data[0]))
        } else {
          console.log('⚠️ No shipments received or empty array')
        }
      })
      .catch(error => {
        console.error('❌ Error fetching shipments:', error)
        console.error('❌ Error details:', error.response?.data || error.message)
        console.error('❌ Full error object:', error)
      })
    
    this.fetchLoadingDocks()
      .then(data => {
        console.log('✅ Loading docks fetched:', data?.length || 0)
        // Para producción: NO crear muelles automáticamente
        // Los muelles deben ser creados manualmente por el administrador
      })
      .catch(error => console.error('❌ Error fetching loading docks:', error))
    
    // Debug: Verificar estado del store después de un breve delay
    setTimeout(() => {
      console.log('🔍 DEBUG: Store state after initialization:')
      console.log('📦 this.shipments:', this.shipments)
      console.log('📦 Store shipments length:', this.shipments?.length || 0)
      console.log('📦 Store shipments type:', typeof this.shipments)
      console.log('📦 Is Array?:', Array.isArray(this.shipments))
      
      // Verificar directamente desde el store
      const storeShipments = this.$store.getters['transactions/allShipments']
      console.log('🏪 Direct from store:', storeShipments)
      console.log('🏪 Store shipments length:', storeShipments?.length || 0)
      
      // Forzar actualización si hay discrepancia
      if (storeShipments.length > 0 && this.shipments.length === 0) {
        console.log('🔧 Forcing Vue reactivity update...')
        this.$forceUpdate()
      }
    }, 3000)
  }
}
</script>


<style scoped>
.despachos-container {
  padding: 20px;
}

.v-card {
  margin-bottom: 20px;
}

.v-chip {
  font-weight: 500;
}

/* Estilos para la tabla de despachos */
.despachos-table {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: white !important;
}

.despachos-table .v-data-table__thead {
  background-color: #f8f9fa !important;
}

.despachos-table .v-data-table__thead .v-data-table__th {
  background-color: #f8f9fa !important;
  font-weight: 600 !important;
  color: #495057 !important;
  border-bottom: 2px solid #dee2e6 !important;
}

.despachos-table .v-data-table__tbody .v-data-table__td {
  padding: 12px 16px !important;
  border-bottom: 1px solid #dee2e6 !important;
}

.despachos-table .v-data-table__tbody tr:hover {
  background-color: #f8f9fa !important;
}

/* Estilos para las tarjetas de muelles */
.dock-card {
  height: 100%;
  transition: all 0.3s ease;
}

.dock-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

/* Estilos para las tarjetas de consolidación */
.consolidation-card {
  height: 100%;
  transition: all 0.3s ease;
  border: 2px solid #e3f2fd !important;
}

.consolidation-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.15) !important;
  border-color: #2196f3 !important;
}

.dock-info p {
  margin-bottom: 8px;
  font-size: 14px;
}

.dock-info strong {
  color: #495057;
}

/* Estilos para las pestañas */
.v-tabs {
  background-color: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 24px;
}

.v-tab {
  font-weight: 500;
  text-transform: none;
}

.v-tab--selected {
  background-color: white;
  border-radius: 6px;
  margin: 4px;
}

/* Estilos para filtros */
.v-text-field, .v-select {
  margin-bottom: 8px;
}

/* Estilos para alertas */
.v-alert {
  border-radius: 8px;
  font-weight: 500;
}

/* Estilos para botones */
.v-btn {
  text-transform: none;
  font-weight: 500;
}

/* Estilos para chips de órdenes en muelles */
.v-chip.ma-1 {
  margin: 2px !important;
}

/* Estilos para progress bars */
.v-progress-linear {
  border-radius: 4px;
}

/* Estilos responsivos */
@media (max-width: 768px) {
  .despachos-container {
    padding: 10px;
  }
  
  .dock-card {
    margin-bottom: 16px;
  }
  
  .v-tabs {
    margin-bottom: 16px;
  }
  
  /* Pestañas responsivas */
  .v-tab {
    font-size: 12px;
    min-width: auto;
    padding: 8px 12px;
  }
  
  .v-tab .v-icon {
    font-size: 16px;
    margin-right: 4px;
  }
  
  /* Headers de cards responsivos */
  .v-card-title {
    padding: 12px 16px;
    font-size: 16px;
  }
  
  .v-card-title span {
    font-size: 14px;
  }
  
  /* Filtros responsivos */
  .v-row .v-col {
    padding: 4px 8px;
  }
  
  /* Botones responsivos */
  .v-btn {
    font-size: 12px;
  }
  
  .v-btn--size-small {
    min-width: 32px;
    height: 32px;
  }
}

/* Estilos para modales */
.v-dialog .v-card {
  border-radius: 12px;
}

.v-dialog .v-card-title {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  font-weight: 600;
}

/* Estilos para formularios */
.v-form .v-row {
  margin-bottom: 8px;
}

/* Animaciones */
.v-window-item {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Estilos para estados de muelles */
.dock-card[style*="success"] {
  border-left: 4px solid #4caf50;
}

.dock-card[style*="warning"] {
  border-left: 4px solid #ff9800;
}

.dock-card[style*="info"] {
  border-left: 4px solid #2196f3;
}

.dock-card[style*="error"] {
  border-left: 4px solid #f44336;
}

/* Estilos para botones de acción */
.action-buttons {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  justify-content: center;
}

.action-buttons .v-btn {
  min-width: 32px;
}

/* Responsive adicional */
@media (max-width: 768px) {
  .action-buttons {
    justify-content: flex-start;
    gap: 8px;
  }
  
  .action-buttons .v-btn {
    min-width: 36px;
    height: 36px;
  }
}

@media (max-width: 480px) {
  .action-buttons .v-btn {
    min-width: 32px;
    height: 32px;
  }
  
  /* Ajustes para móviles pequeños */
  .despachos-container {
    padding: 8px;
  }
  
  .v-card {
    margin-bottom: 12px;
  }
  
  .v-card-title {
    padding: 8px 12px;
    font-size: 14px;
  }
  
  .v-card-title span {
    font-size: 13px;
  }
  
  .v-card-text {
    padding: 12px;
  }
  
  /* Pestañas para móviles pequeños */
  .v-tab {
    font-size: 11px;
    padding: 6px 8px;
  }
  
  .v-tab .v-icon {
    font-size: 14px;
    margin-right: 2px;
  }
  
  /* Filtros para móviles pequeños */
  .v-text-field, .v-select {
    font-size: 12px;
  }
  
  .v-field__input {
    font-size: 12px;
  }
  
  /* Chips más pequeños */
  .v-chip {
    font-size: 10px;
    height: 20px;
  }
  
  /* Botones más compactos */
  .v-btn {
    font-size: 11px;
    min-height: 28px;
  }
}
</style>
